import { useEffect, useState } from "react";
import { Card, Row, Col, Spinner, Alert, Button, Table } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import api from "@/api/api.js";

const safe = (v) => (v === null || v === undefined || v === "" ? "—" : v);

const ClientUserDetail = () => {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!userId) return;
    let active = true;
    setLoading(true);
    api
      .get(`/users/${userId}`)
      .then(({ data }) => active && setUser(data))
      .catch(
        () =>
          active && setError("No se pudo cargar la información del usuario."),
      )
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [userId]);

  if (loading) {
    return (
      <div className="d-flex align-items-center gap-2 p-3">
        <Spinner animation="border" size="sm" />
        <span>Cargando...</span>
      </div>
    );
  }

  if (error || !user) {
    return (
      <div className="col">
        <Alert variant="warning">{error || "Usuario no encontrado."}</Alert>
        <Button as={Link} to="/client-users" variant="secondary">
          Volver
        </Button>
      </div>
    );
  }

  const profile = user.userProfile || {};
  const companies = Array.isArray(user.companies) ? user.companies : [];

  return (
    <Row className="g-3">
      <Col xs={12} md={5}>
        <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <span className="fw-bold">Datos del usuario</span>
            <Button as={Link} to="/client-users" variant="secondary" size="sm">
              Volver
            </Button>
          </Card.Header>
          <Card.Body>
            <div>
              <strong>Nombre:</strong>{" "}
              {safe(`${profile.name ?? ""} ${profile.lastname ?? ""}`.trim())}
            </div>
            <div>
              <strong>Email:</strong> {safe(user.username)}
            </div>
            <div>
              <strong>Tipo:</strong> {safe(profile.userType)}
            </div>
            <div>
              <strong>Teléfono:</strong> {safe(profile.telephoneContact)}
            </div>
          </Card.Body>
        </Card>
      </Col>

      <Col xs={12} md={7}>
        <Card>
          <Card.Header className="fw-bold">
            Compañías creadas por el usuario ({companies.length})
          </Card.Header>
          <Card.Body>
            {companies.length === 0 ? (
              <span className="text-muted">
                Este usuario no ha creado compañías.
              </span>
            ) : (
              <Table responsive hover size="sm" className="mb-0">
                <thead>
                  <tr>
                    <th>Razón social / Nombre</th>
                    <th>RFC</th>
                    <th className="text-end">Detalle</th>
                  </tr>
                </thead>
                <tbody>
                  {companies.map((c) => {
                    const cid = c["@id"]?.split("/").pop();
                    return (
                      <tr key={cid}>
                        <td>{safe(c.name)}</td>
                        <td>{safe(c.taxIdentification)}</td>
                        <td className="text-end">
                          <Link
                            to={`/${cid}/detailCompany`}
                            className="btn btn-outline-info btn-sm"
                          >
                            <i className="bi bi-eye" />
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default ClientUserDetail;
